<template>
  <div class="bindPhone">
    <component :is="bindPhoneComponent"
               @fnBtnClick="fnBtnClick"></component>
  </div>
</template>

<script>
import BindPhoneDefault from '../components/BindPhoneDefault'
import BindPhoneStep from '../components/BindPhoneStep'
export default {
  name: 'BindPhone',
  data () {
    return {
      bindPhoneComponent: 'BindPhoneDefault'
    }
  },
  components: {
    BindPhoneDefault,
    BindPhoneStep
  },
  methods: {
    fnBtnClick (type) {
      switch (type) {
        case 'bindPhoneStep':
          this.bindPhoneComponent = 'BindPhoneStep'
          break
        case 'closeModal':
          this.$emit('fnBtnClick', {
            dataType: 'modalSlotClose',
            dataClose: 'wndMultiPhone'
          })
          break
        case 'exitClient':
          this.Storage.del(['USER', 'hasGameWnd'])
          this.Storage.del('launchTimes')
          setTimeout(() => {
            this.fnCefGameBox({
              method: 'ExitClient'
            })
          }, 500)
          break
      }
    }
  }
}
</script>
